/// <amd-module name="Build/Admin/Common/Services/ProjectDataService" />
import { TaskAgentPool, TaskAgentQueue } from "DistributedTask/Client/Contracts/TaskAgent";

import { getTFSPageData, IProjectData } from "Tfs/Platform/Page";

import { IVssPageContext, IVssService, Services, VssService } from "VSS/Platform/Context";

export interface IProjectDataService extends IVssService {
    hasProjectData(): boolean;
    getProjectData(): IProjectData | undefined;
}

class ProjectDataService extends VssService implements IProjectDataService {
    private _projectData: IProjectData | undefined;

    // tslint:disable-next-line:function-name
    public _serviceStart(pageContext: IVssPageContext): void {
        super._serviceStart(pageContext);

        const tfsPageData = getTFSPageData(this.pageContext);
        this._projectData = tfsPageData && tfsPageData.project;
    }

    public hasProjectData(): boolean {
        return Boolean(this._projectData);
    }

    public getProjectData(): IProjectData | undefined {
        return this._projectData;
    }
}

Services.add("IProjectDataService", { serviceFactory: ProjectDataService });
